export enum DateFormat {
  DATE = 'date',
  TIME = 'time',
  DATETIME = 'date-time',
}
